// extracted by mini-css-extract-plugin
module.exports = {"container":"e__z","up":"e_0z","down":"e_1z","percent":"e_2z","percentVal":"e_3z","title":"e_4z","tags":"e_5z","textBadge":"e_6z"};